import axios from 'axios'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.withCredentials = true;
import wechattype from '../utils/environment'
// let baseUrl = 'http://ihos.propersoft.cn/wx-api'
let baseUrl = 'https://wxhos.asszyy.cn/wx-api'
// let baseUrl = '/api'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://wx.propersoft.cn/wx-api', //域名
  baseURL: baseUrl, //鞍山服务器
  // baseURL: 'http://172.168.1.217:9999', //生明
  // baseURL: 'http://172.168.3.172:8080', //韩哥
  // baseURL: 'http://nynbp8.natappfree.cc', //景

  // 超时
  timeout: 100000,
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    // if (getToken()) {
    //   config.headers['TOKEN'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    const code = res.data.code
    if (code === 401) {
      //无权限跳转
      return res.data
    } else if (code === 110) {
      localStorage.clear()
      let uri = getHrefQuery()
      let state = getStateQuery()

      //判断是不是微信
      if (wechattype) {
        console.log('wechat01');

        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx31e205b69fed7451&redirect_uri=' +

          // 测试
          // encodeURIComponent(window.location.origin + '/#/login' + uri) +

          // vpn
          encodeURIComponent('https://wxhos.asszyy.cn' + '/#/login' + uri) +
          '&response_type=code&scope=snsapi_userinfo&state=' +
          state +
          '#wechat_redirect'

        return res.data
      } else {
        console.log('alipay01');

        window.location.href =
          'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm' +
          '?app_id=2021002112670557' +
          '&scope=auth_base' +
          '&redirect_uri=' + encodeURIComponent('https://wxhos.asszyy.cn' + '/#/login') +
          '&response_type=code' +
          '&state=' + state
        return res.data
      }

    } else if (code !== 200) {
      //错误弹窗
      return res.data
    } else {
      return res.data
    }
  },
  (error) => {
    // 错误提示
    return Promise.reject(error)
  }
)

function getStateQuery () {
  let href = window.location.href
  if (href.indexOf('?') != -1) {
    return href.substring(href.indexOf('#/') + 2, href.indexOf('?'))
  } else {
    return href.substring(href.indexOf('#/') + 2, href.length)
  }
}
function getHrefQuery () {
  let href = window.location.href
  if (href.indexOf('?') != -1) {
    return href.substring(href.indexOf('?'), href.length)
  } else {
    return ''
  }
}
export default service

export function getBaseUrl () {
  return baseUrl
}
